<template>
  <div id="propertyReport">
    <header-top></header-top>
    <div class="header-title">楼盘统计报表</div>
    <div class="property-main">
      <div class="property-menu">
        <el-collapse v-model="activeNames">
          <el-collapse-item
            :title="item.name"
            :name="item.name"
            v-for="(item, index) in propertyTypeList"
            :key="index"
            :class="{
              'no-child': !item.children,
              'color-item': !item.children && parentName == item.name,
            }"
            @click.native="selectParent(item)"
          >
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="property-table">
        <statistical v-if="parentName == '统计报表'" />
        <business-daily v-if="parentName == '营业日报'" />
        <marketing-chart v-if="parentName == '营销分析趋势图'" />
      </div>
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import statistical from "./subpage/statistical";
import businessDaily from "./subpage/business-daily";
import marketingChart from "./subpage/marketing-chart";
export default {
  components: {
    headerTop,
    statistical,
    businessDaily,
    marketingChart,
  },
  data() {
    return {
      parentName: "",
      activeNames: [],
      propertyList: [],
      propertyTypeList: [
        {
          name: "统计报表",
        },
        {
          name: "营业日报",
        },
        {
          name: "营销分析趋势图",
        },
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.parentName = this.propertyTypeList[0].name;
      this.activeNames = [this.parentName];
    },
    selectParent(v) {
      //console.log(v, 666);
      if (!v.children) {
        this.parentName = v.name;
        this.isEditShow = false;
      }
      //console.log(this.parentName, "parentName");
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#propertyReport {
  .property-main {
    padding: 20px;
    @include flex(row, flex-start);
    justify-content: space-between;

    .property-menu {
      box-sizing: border-box;
      border-radius: $--border-radius-base;
      padding: 16px 0;
      width: 220px;
      min-height: calc(100vh - 160px);
      background: #fff;
    }

    .property-table {
      margin-left: 20px;
      width: calc(100% - 240px);
      min-height: calc(100vh - 160px);
      // background: #fff;
      box-sizing: border-box;
      border-radius: $--border-radius-base;
      .main-header {
        display: flex;
        justify-content: space-between;
        align-items: center;

        padding: 20px;
        border-bottom: 1px solid #ddd;
        background: #fff;
        .header-title {
          font-size: 16px;
        }

        .edit-btn {
          color: #fff;
          background-color: $--color-primary;
        }
      }

      .property-content {
        height: calc(100% - 71px);
        // padding: 20px;
      }
    }
  }
}
</style>
